"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _clsx = _interopRequireDefault(require("clsx"));

var _Ai = require("./Ai.styles");

var _icons = require("../../assets/icons");

var AiError = function AiError(props) {
  var className = props.className;
  return (0, _jsxRuntime.jsx)("div", {
    className: (0, _clsx["default"])(className, 'grui'),
    css: _Ai.styles.spinnerContainer,
    children: (0, _jsxRuntime.jsxs)("div", {
      className: "gr-centered",
      children: [(0, _jsxRuntime.jsx)(_icons.Negative, {
        css: _Ai.styles.warningIcon
      }), (0, _jsxRuntime.jsx)("div", {
        css: _Ai.styles.textContainer,
        children: (0, _jsxRuntime.jsx)("span", {
          css: _Ai.styles.spinnerIconText,
          children: "Oh no, something went wrong!"
        })
      })]
    })
  });
};

AiError.propTypes = {
  className: _propTypes.string
};
AiError.defaultProps = {
  className: ''
};
var _default = AiError;
exports["default"] = _default;
//# sourceMappingURL=AiError.js.map